import React from 'react'
import { connect } from 'react-redux'
import { change as changeFieldValue, reduxForm } from 'redux-form';
import {
  PERFIL_ADMIN
} from '../../security/securityContext';
import Autorizacao from '../../security/Autorizacao';

export class ImpostoEmpresa extends React.Component {
  selecionarEmpresa (impostoEmpresa) {
    this.props.changeFieldValue('formImpostoEmpresa',
      'id', impostoEmpresa.id);

    this.props.changeFieldValue('formImpostoEmpresa',
      'codigoEmpresa', impostoEmpresa.codigoEmpresa);

    const imposto = {label: impostoEmpresa.siglaImposto, value: impostoEmpresa.siglaImposto}
    this.props.changeFieldValue('formImpostoEmpresa',
      'impostoEmpresa.siglaImposto', imposto);

    this.props.changeFieldValue('formImpostoEmpresa',
      'aliquota', impostoEmpresa.aliquota);

    this.props.changeFieldValue('formImpostoEmpresa',
      'desconto', impostoEmpresa.desconto);

  }

  render () {
    return (
      <Autorizacao perfisPermitidos={[PERFIL_ADMIN]}>
      <div className="representante">
        <div className="resumo">
          <div className="row">
            <div className="col-lg-6 col-xl-6">
              <span className="titulo-mobile">Sigla:&nbsp;</span>{this.props.impostoEmpresa.siglaImposto}
            </div>
            <div className="col-lg-2 col-xl-23">
              <span className="titulo-mobile">Aliquota:&nbsp;</span>{this.props.impostoEmpresa.aliquota}
            </div>

            <div className="col-lg-2 col-xl-23">
              <span className="titulo-mobile">Desconto:&nbsp;</span>{this.props.impostoEmpresa.desconto}
            </div>
            
            <div className="col-lg-2 col-xl-2">
              <div className="acoes">
                      <div className="botoes">
                        <button type="button" className="btn btn-excluir"
                                data-toggle="modal"
                                onClick={() => this.props.excluirImpostoEmpresa(this.props.impostoEmpresa.id)}>
                          <i className="material-icons nav-icon">&#xe872;</i>
                        </button>
                      </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      </Autorizacao>
    )
  }
}

export default connect(null, { changeFieldValue })(reduxForm({
  form: 'formImpostoEmpresa'
})(ImpostoEmpresa))
